'use client';

import type { Theme, SxProps } from '@mui/material/styles';
import type { ManualId } from 'src/types/manual/manual-domain';

import Button from '@mui/material/Button';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { planViewerOfUser } from 'src/utils/plan/plan-tier';
import { canReadManual } from 'src/utils/manual/manual-path';

import { Iconify } from 'src/components/iconify';

import { useAuthContext } from 'src/auth/hooks';

/**
 * 화면 머리의 「사용 가이드」 — 그 화면의 매뉴얼(`/guide/<id>`)을 같은 탭에서 연다.
 *
 * 🔑 읽을 수 없는 사람에게는 서지 않는다 — 판정은 가이드 화면·API 관문과 같은 `canReadManual` 이다
 *   (`GUIDE_MIN_PLAN` 이 `null` 이면 늘 선다).
 * @param id 이 화면의 매뉴얼 id(`MANUAL_CATALOG` 의 id)
 * @param sx 자리 보정(여백·정렬)만 — 모양은 여기서 정한다
 */
export function ManualGuideLink({ id, sx }: { id: ManualId; sx?: SxProps<Theme> }) {
  const { user } = useAuthContext();
  if (!canReadManual(planViewerOfUser(user), id)) return null;

  return (
    <Button
      component={RouterLink}
      href={paths.guide.manual(id)}
      size="small"
      color="inherit"
      data-manual-guide-link={id}
      startIcon={<Iconify icon="solar:book-linear" width={16} />}
      sx={[{ flexShrink: 0, color: 'text.secondary', whiteSpace: 'nowrap' }, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      사용 가이드
    </Button>
  );
}
